import { FEATURE_FLAGS_DEFAULTS } from '@/constants/featureFlags'
import type { FeatureFlag } from '@/types'
import getLangsVariable from '@/utils/getLangsVariable'

export const useFeatureFlags = () => {
  const isFeatureEnabled = (flag: FeatureFlag): boolean => {
    const remoteValue: unknown = getLangsVariable(['FEATURE_FLAGS', flag])
    return typeof remoteValue === 'boolean' ? remoteValue : FEATURE_FLAGS_DEFAULTS[flag]
  }

  return { isFeatureEnabled }
}
